import { render } from "./errorPage4.vue?vue&type=template&id=69092df2&scoped=true"
const script = {}

import "./errorPage4.vue?vue&type=style&index=0&id=69092df2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69092df2"]])

export default __exports__